import { useCallback, useEffect, useRef } from 'react';
import connect from 'components/Shared/connect';
import { IMenuItem } from 'models/IMenuItem';
import styles from './styles.scss';
import cn from 'classnames';
import { delay } from 'utils';
import { closeMainMenu, isPageLoading, openMainMenu } from 'components/MainMenu/actions';
import { OurBrands } from './ourBrands';
import { Section } from './sectionItem';
import { selectSections } from 'components/MainMenu/selectors';
import { useMenuToggle } from 'components/MainMenu/useMenuToggle';
import { isHuge } from 'components/Shared/responsive';
import { selectBlackFridayStatus } from 'components/Header/themes/BGH/selector';
import { useSelector } from 'react-redux';

interface MergedProps {
  sections: IMenuItem[];
  isLoading: boolean;
  isOpen: boolean;
  openMainMenu: () => void;
  closeMainMenu: () => void;
  isHuge: boolean;
}
export default connect<MergedProps>(
  state => ({
    sections: selectSections(state),
    isLoading: isPageLoading(state.currentPage),
    isOpen: state.header.mainMenu.isOpen,
    isHuge: isHuge({ currentBreakpoint: state.currentBreakpoint })
  }),
  dispatch => ({
    openMainMenu: () => dispatch(openMainMenu()),
    closeMainMenu: () => dispatch(closeMainMenu())
  })
)(function DesktopMenu({
  sections,
  isLoading,
  isOpen,
  openMainMenu,
  closeMainMenu,
  isHuge
}: MergedProps) {
  const delayRef = useRef(delay());
  const blackFridayIsActive = useSelector(selectBlackFridayStatus);
  useEffect(() => delayRef.current.cleanup, []);
  const toggle = useCallback(
    (open: boolean) => delayRef.current.setDelay(() => (open ? openMainMenu() : closeMainMenu())),
    [openMainMenu, closeMainMenu]
  );
  const onMouseOver = () => toggle(true);
  const onMouseOut = () => toggle(false);
  const [openId, open, close] = useMenuToggle<string>(isOpen, isLoading);
  return (
    <nav
      className={cn(styles.main, {
        [styles.open]: isOpen,
        [styles.blackFriday]: blackFridayIsActive
      })}
    >
      <div className={cn(styles.sectionWrapper, { [styles.blackFriday]: blackFridayIsActive })}>
        <span
          className={styles.sectionInternalWrapper}
          onMouseOut={onMouseOut}
          onTouchStart={onMouseOver}
          onMouseOver={onMouseOver}
        >
          {sections.map(s => (
            <Section
              key={s.id}
              isParentOpen={isOpen}
              {...s}
              openMenu={open(s.id)}
              closeMenu={close}
              isLoading={isLoading}
              openId={openId}
            />
          ))}
          {!isHuge && <OurBrands />}
        </span>
        {isHuge && <OurBrands outside />}
      </div>
    </nav>
  );
});
